// Copyright (c) 2022 by Move Closer

import { AnyObject } from '@movecloser/front-core'
import { SubscribeConfig } from '@kluseg/trackify'

/**
 * Service capable of communicating with the User.com UDP (User Data Platform).
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl> (edited)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export interface IUserComService {
  /**
   * Initialize UserCom script
   */
  init: () => Promise<void>

  /**
   * Subscribes new User to the newsletter.
   *
   * @param formData - Data entered by the User.
   * @param eventName - Name of the event for which form data is sent.
   */
  subscribe: (formData: NewsletterFormData | SubscribeConfig, eventName?: string) => void

  /**
   * Send track event to user
   *
   * @param event - event name
   * @param data - user data.
   */
  event: (eventName: string, data: AnyObject) => Promise<void>

  /**
   * TODO: Doc.
   */
  initialized: () => boolean

  /**
   * Update client data
   *
   * @param data - user data
   */
  updateUser (data: AnyObject): void
}

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export interface NewsletterFormData {
  /**
   * User's e-mail address.
   */
  email: string

  /**
   * User's name.
   */
  name: string
}

/**
 * Configuration object required by the `UserComService`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export interface UserComConfig {
  /**
   * Unique API key that enables connection between the application and the User.com.
   */
  apiKey: string

  /**
   * The URL address from which the User.com JS script should be fetched from.
   */
  endpoint: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export const UserComServiceType = Symbol.for('IUserComService')
